import { render } from "./FriendChatOut.vue?vue&type=template&id=f57987a8&scoped=true"
import script from "./FriendChatOut.vue?vue&type=script&lang=js"
export * from "./FriendChatOut.vue?vue&type=script&lang=js"

import "./FriendChatOut.vue?vue&type=style&index=0&id=f57987a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57987a8"]])

export default __exports__